import { render, staticRenderFns } from "./TextBook.vue?vue&type=template&id=444b6d60&scoped=true"
import script from "./TextBook.vue?vue&type=script&lang=js"
export * from "./TextBook.vue?vue&type=script&lang=js"
import style0 from "./TextBook.vue?vue&type=style&index=0&id=444b6d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b6d60",
  null
  
)

export default component.exports